module.exports = ".view-question {\n  text-align: center; }\n\na {\n  cursor: pointer; }\n\n.animate h1, .animate h2, .animate p {\n  opacity: 0; }\n\n.animate .btn {\n  opacity: 0;\n  bottom: -25px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/step/step.component.scss
// module id = ./src/app/components/step/step.component.scss
// module chunks = main